import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // disables false eslint false positive as alt tags must be based by prop

/* eslint-disable jsx-a11y/alt-text */

import React, { useState } from 'react';
import Observer from '@researchgate/react-intersection-observer';
import styles from 'wienenergiedesignsystem/components/Image/Image.module.scss';

var Image = function Image(_ref) {
  var srcSet = _ref.srcSet,
      src = _ref.src,
      className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, ["srcSet", "src", "className"]);

  var _useState = useState(false),
      isIntersecting = _useState[0],
      setIntersecting = _useState[1];

  var handleChange = function handleChange(event) {
    if (event.intersectionRatio > 0) {
      setIntersecting(true);
    }
  };

  return /*#__PURE__*/React.createElement(Observer, {
    onChange: handleChange,
    rootMargin: "33% 0% 33%"
  }, /*#__PURE__*/React.createElement("img", Object.assign({
    className: !isIntersecting ? styles.hidden : className,
    src: !isIntersecting ? null : src,
    srcSet: !isIntersecting ? null : srcSet
  }, rest)));
};

export { Image as default };